import { type RowData } from '@tanstack/react-table';
import { type LegacyColumn as Column } from '@tanstack/react-table/legacy';
import SelectableFilter from './SelectableFilter';
import { RangeFilter, SearchFilter } from './TextFilters';

export const Filter = <T extends RowData>({ column }: { column: Column<T> }) => {
  const { filterVariant } = column.columnDef.meta ?? {};

  switch (filterVariant) {
    case 'range':
      return <RangeFilter column={column} />;

    case 'select':
      return <SelectableFilter column={column as Column<T, string | number>} />;

    case 'text':
      return <SearchFilter column={column} />;
    default:
      return null;
  }
};
